import { useCandidatesOverviewContext } from '../../Contexts/CandidatesOverviewContext/CandidatesOverviewContext';
import BaseFilter from './BaseFilter';
import HiringStatusFilterPanel from './HiringStatusFilterPanel';
import UIStrings from '@/Utils/UIStrings';

function HiringStatusFilterButton() {
    const { hiringStatusFilter } = useCandidatesOverviewContext();

    return (
        <BaseFilter label={UIStrings.HiringStage} activeFilterCount={hiringStatusFilter.length}>
            <HiringStatusFilterPanel />
        </BaseFilter>
    );
}

export default HiringStatusFilterButton;
